export const numLines = 3;
export const defaultFontSize = "12.5vw";
export const artexWord = "Artex";
export const movementWord = "Movement";
export const leMansWord = "Le Mans";
export const baseTextPadding = "100px 30px";
export const rows3Class = "rows-3";
export const row1Class = "row-1";
